/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  return !param.includes('-from-')

  // return /^(.+)-(vaccinated|unvaccinated)$/.test(param)
}
